import { render, staticRenderFns } from "./mealBookForm.vue?vue&type=template&id=dc056e96&scoped=true"
import script from "./mealBookForm.vue?vue&type=script&lang=js"
export * from "./mealBookForm.vue?vue&type=script&lang=js"
import style0 from "./mealBookForm.vue?vue&type=style&index=0&id=dc056e96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc056e96",
  null
  
)

export default component.exports